module.exports = __webpack_public_path__ + "img/Women’s Multivitamin.da1f0ceb.png";